/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateManagementHeaderContainer as TemplateManagementHeader } from './TemplateManagementHeader.container';
